import React from "react";

const BOTANICAL = "https://customer-assets.emergentagent.com/job_practice-portal-15/artifacts/n53vyhq0_%20-5.jpg";

export default function Philosophy() {
    return (
        <section id="philosophy" data-testid="philosophy-section" className="relative py-28 lg:py-44 overflow-hidden" style={{ background: "#F2EDE6" }}>
            {/* botanical wash — single right-side ornament, heavily cropped to hide watermark, very low opacity */}
            <div className="absolute -right-40 -top-40 h-[150%] w-[55%] lg:w-[42%] pointer-events-none opacity-[0.10] overflow-hidden" aria-hidden>
                <img src={BOTANICAL} alt="" className="w-full h-full object-cover object-[35%_15%] scale-[2.2]" />
            </div>

            {/* sage-cream center wash */}
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[55%] bg-gradient-to-b from-rose-cream/0 via-sage-mist/40 to-rose-cream/0 pointer-events-none" aria-hidden />

            <div className="relative z-10 mx-auto max-w-[1000px] px-6 lg:px-12 text-center" data-reveal>
                <span className="text-[11px] tracking-[0.5em] uppercase text-gold-dark">The Alchemy</span>

                <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal text-balance">
                    From <em className="italic text-gold">nigredo</em> to <em className="italic text-gold">rubedo</em><span className="text-gold"> — </span>
                    <br className="hidden sm:block" />
                    from what has been buried, to what has been integrated.
                </h2>

                <div className="mt-14 flex items-center justify-center gap-6 text-gold">
                    <span className="h-px w-24 bg-gold/60" />
                    <span className="font-serif text-2xl text-rose-dark">✦</span>
                    <span className="h-px w-24 bg-gold/60" />
                </div>

                <p className="mt-14 text-lg sm:text-xl leading-[1.95] text-charcoal-soft max-w-3xl mx-auto text-pretty">
                    The ancient alchemists were never really after gold. They were after transformation —
                    the slow, patient work of meeting what was raw within the self and tending it into
                    something more refined. They called the final stage <em className="italic text-gold">rubedo</em>:
                    the earned depth, the integrated self, the wisdom that only arrives on the other
                    side of having moved through.
                </p>

                <p className="mt-8 text-lg sm:text-xl leading-[1.95] text-charcoal-soft max-w-3xl mx-auto text-pretty">
                    Therapy, at its best, is the same work. Not erasure. Not optimization. Not becoming
                    someone new. Just — gently, deliberately — becoming more fully who you already are
                    beneath what life has asked you to carry.
                </p>

                <blockquote
                    className="mt-16 inline-block text-left"
                    style={{
                        borderLeft: "3px solid #9B7D5A",
                        paddingLeft: "20px",
                    }}
                >
                    <p className="font-serif italic text-2xl sm:text-3xl text-gold max-w-2xl leading-snug">
                        "The wound is the place where the light enters you."
                    </p>
                    <p className="mt-3 text-[11px] tracking-[0.4em] uppercase text-gold">— Rumi</p>
                </blockquote>
            </div>
        </section>
    );
}
